import A101Logo from "@/assets/companies/a101-logo.svg";
import ArvatoLogo from "@/assets/companies/arvato-logo.svg";
import BalormanIntLogo from "@/assets/companies/balorman-int-logo.svg";
import EnerjiSALogo from "@/assets/companies/enerjisa-logo.svg";
import PakmayaLogo from "@/assets/companies/pakmaya-logo.svg";
import SodexoLogo from "@/assets/companies/sodexo-logo.svg";

export const COMPANIES = [
  {
    imgUrl: EnerjiSALogo,
    alt: "Enerjisa Logo",
  },
  {
    imgUrl: A101Logo,
    alt: "A101 Logo",
  },
  {
    imgUrl: PakmayaLogo,
    alt: "Pakmaya Logo",
  },
  {
    imgUrl: BalormanIntLogo,
    alt: "Balorman Logo",
  },
  {
    imgUrl: ArvatoLogo,
    alt: "Arvato Logo",
  },
  {
    imgUrl: SodexoLogo,
    alt: "Sodexo Logo",
  },
];
